import { testimonials } from '@/mocks/articles';

export default function EditorQuote() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-[1440px]">
        <div className="flex flex-col lg:flex-row items-center gap-0">
          <div className="w-full lg:w-[60%] py-8 lg:py-12">
            <div className="flex items-center gap-2 mb-10">
              <span className="w-2.5 h-2.5 rounded-full bg-foreground-950"></span>
              <span className="text-xs font-medium text-foreground-600 uppercase tracking-wider">主编推荐</span>
            </div>

            <blockquote className="max-w-md">
              <span className="font-heading text-7xl text-foreground-300 leading-none">&ldquo;</span>
              <p className="font-heading text-2xl md:text-3xl text-foreground-950 leading-relaxed mt-2">
                吃瓜不是围观，是一种对真相的执着。我们坚持用最快的速度，为你呈现最真实的娱乐江湖。
              </p>
            </blockquote>

            <div className="flex items-center gap-2 mt-8">
              <span className="text-sm font-bold text-foreground-950">主编 · 老王</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-verified-badge-fill text-accent-500 text-sm"></i>
              </span>
              <span className="text-xs text-foreground-500">黑料入口编辑部</span>
            </div>

            <div className="flex flex-wrap gap-3 mt-8">
              {testimonials.map((t) => (
                <div
                  key={t.id}
                  className="bg-background-100 rounded-lg px-4 py-2.5 flex items-center gap-2"
                >
                  <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">{t.name}</span>
                  <span className="text-xs text-foreground-500">·</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{t.role}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[40%]">
            <div className="w-full h-[400px] lg:h-[550px] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20photography%20of%20a%20stylish%20Asian%20person%20in%20profile%20looking%20upward%20with%20contemplative%20expression%2C%20dramatic%20side%20lighting%20creating%20strong%20shadows%20across%20the%20face%2C%20high%20contrast%20monochrome%2C%20editorial%20fashion%20photography%20style%2C%20clean%20white%20seamless%20background%2C%20fine%20art%20portrait%20aesthetic%20with%20subtle%20grain%20texture&width=600&height=800&seq=editor-portrait&orientation=portrait"
                alt="黑料入口主编"
                title="黑料入口编辑部"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}